import React from 'react';
export const EyeOpenSvg: React.FC = () => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0C6.27273 0 2.23364 2.86667 0 7C2.23364 11.1333 6.27273 14 11 14C15.7273 14 19.7664 11.1333 22 7C19.7664 2.86667 15.7273 0 11 0ZM11 11.6667C8.42273 11.6667 6.33364 9.57778 6.33364 7C6.33364 4.42222 8.42273 2.33333 11 2.33333C13.5773 2.33333 15.6664 4.42222 15.6664 7C15.6664 9.57778 13.5773 11.6667 11 11.6667ZM11 4.08333C9.38818 4.08333 8.08364 5.38889 8.08364 7C8.08364 8.61111 9.38818 9.91667 11 9.91667C12.6118 9.91667 13.9164 8.61111 13.9164 7C13.9164 5.38889 12.6118 4.08333 11 4.08333Z"
        fill="#888888"
      />
    </svg>
  );
};
